// extracted by mini-css-extract-plugin
export default {"row":"row__-31c5580e","column":"column__-31c5580e","label":"label__-31c5580e","logo":"logo__-31c5580e"};